import { mapGetters, mapMutations } from "vuex";
import alertHelper from "@/helper/AlertHelper";
import Common from "@/common";

export const shaparakResultMixin = {
  data() {
    return {
      paymentId: "",
      checkUrl: "",
      timestamp: "",
    };
  },
  computed: {
    ...mapGetters([
      "getShaparakPayingAmount",
      "getStepperPage",
      "getPaymentSuccess",
      "getVersion",
      "getShaparakTransactionRefNumber",
      "getTransactionCompleteTime",
      "getShaparakCallBackUrl",
    ]),
  },
  methods: {
    ...mapMutations(["setStepperPage"]),
    getNow() {
      const today = new Date();
      const date =
        today.getFullYear() +
        "/" +
        (today.getMonth() + 1) +
        "/" +
        today.getDate();
      const time = this.msToTime(this.getTransactionCompleteTime);
      this.timestamp = time + " - " + date;
    },

    msToTime(duration) {
      let seconds = Math.floor((duration / 1000) % 60),
          minutes = Math.floor((duration / (1000 * 60)) % 60),
          hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      return hours + ":" + minutes + ":" + seconds;
    },

    goToCallBackUrl() {
      if (this.getVersion === "v1")
        window.location.href = Common.createCallback(
          this.getShaparakCallBackUrl,
          this.paymentId,
          1
        );
      else if (this.getVersion === "v2") {
        alertHelper.transactionSuccessAlert(
          "پرداخت موفق",
          "حساب کاربری شما تا لحظاتی دیگر شارژ میشود",
          10000
        );
      }
    },
    autoGoToCallBackUrl() {
      if (this.getPaymentSuccess) {
        setTimeout(this.goToCallBackUrl, 500);
      }
    },

    tryAgain() {
      this.setStepperPage("pageOne");
    },
  },
  watch: {
    getStepperPage(value) {
      if (value === "pageThree") {
        this.getNow();
        this.autoGoToCallBackUrl();
      }
    },
  },
  created() {
    this.getNow();
    this.paymentId = this.$route.query.id;
    this.autoGoToCallBackUrl();
  },
};
